import Vconsole from 'vconsole'

if (
  process.env.VUE_APP_MODE !== 'pro' &&
  !['macintel', 'win32'].includes(navigator.platform.toLowerCase())
) {
  new Vconsole()
}
